import { TypeInitProps, TypeRequest } from '../../types';
import { AUTH_URL } from '../../utils/urls';
export default class CommonAPI {
  private request: TypeRequest;
  constructor(props: TypeInitProps & { request: TypeRequest }) {
    const { request } = props;
    this.request = request;
  }

  /**
   * @param {string} mode - mode
   * @param {string} scene - scene
   * @return {Promise} - send result
   */
  webSdkInit = (params: {
    mode: string;
    scene: string;
    extra_params?: object;
  }) => {
    const { mode, scene, extra_params = {} } = params;
    return this.request({
      url: AUTH_URL.WEB_SDK_INIT,
      method: 'POST',
      data: {
        mode,
        scene,
        ...extra_params,
      },
    });
  };
}
